// TO-DO - Change to api positions response (strategiesQuantities) field
export default function getStrategyLegsType(strategyQuantities?: any) {
  if (!strategyQuantities) return 0;

  const {
    nakedQuantity = 0,
    coveredQuantity = 0,
    spreadQuantities = [],
  } = strategyQuantities;

  const hasNaked = nakedQuantity > 0;
  const hasCovered = coveredQuantity > 0;
  const hasSpread =
    Array.isArray(spreadQuantities) &&
    spreadQuantities.some((s) => s?.quantity > 0);

  const active = [hasNaked, hasCovered, hasSpread].filter(Boolean);

  if (active.length === 0) return 0;
  if (active.length >= 2) return 4;

  if (hasNaked) return 1;
  if (hasCovered) return 2;
  if (hasSpread) return 3;

  return 0;
}
